import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchPricingACQ129 } from './branches/BranchACQ129';
import { BranchManagementLevelACQ130 } from './branches/BranchACQ130';
import { BranchBIAB004, BranchBusinessBox } from './branches/BranchBIAB004';
import { BranchCampaignAssistant } from './branches/BranchCampaignAssistant';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchFreeCRMTour } from './branches/BranchFreeCRMTour';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
const DefaultBranches = [BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber, BranchPricingACQ129, BranchManagementLevelACQ130];
export const FlowBranches = {
  [Flow.Crm]: [...softwareSignupBranches, BranchBIAB004, BranchBusinessBox, BranchFreeCRMTour],
  [Flow.Marketing]: [...softwareSignupBranches, BranchCampaignAssistant],
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch],
  [Flow.Service]: softwareSignupBranches,
  [Flow.CmsFree]: [BranchCmsBusinessMaturity, ...softwareSignupBranches],
  [Flow.Trial]: [BranchPricingACQ129],
  [Flow.Purchase]: [BranchPricingACQ129]
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};